// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"x2-z","colorTextValue":"y2-z","swatches":"z2-z","collapseLink":"A2-z","isCollapsed":"B2-z","dropdown":"C2-z","disabled":"D2-z"};